import styled from 'styled-components'

export const SFormRow = styled.div`
    width: 100%;
    padding-bottom: 15px;
    margin-top: 6px;
    &.right-align {
        justify-content: flex-end;
    }
`

export const SSubHeadings = styled.div`
    display: flex;
    gap: 7px;
    font-family: ${({ theme }) => theme.font.name};
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 1%;
    margin-bottom: ${({ theme }) => theme.sizing.margin.m};
    @media (max-width: 768px) {
        margin: ${({ theme }) => theme.sizing.margin.m};
    }
`

export const SContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme }) => theme.sizing.margin.xl};
`

export const SLabelText = styled.div<{ required?: boolean }>`
    font-family: ${({ theme }) => theme.font.name};
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 1%;
    margin-top: ${({ theme }) => theme.sizing.margin.m};
    color: ${({ theme }) => theme.brandColors.CA_Dark_Gray};
    &::after {
        content: ${({ required }) => (required ? '"*"' : '""')};
    }
`

export const NoBorderButton = styled.span`
    background: transparent;
    border: none;
    margin-left: 3px;
    cursor: pointer;
`
